export class UsersService {
  constructor(axios, apiUrl) {
    this.$axios = axios;
    this.apiUrl = apiUrl;
  }

  async getUserById(id) {
    return await this.$axios.get(
      this.apiUrl + "Users/User/" + id
    ).then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      return {error: error, response: error.response.data };
    }); 
  }

  async getUserByAddress(address) {
    return await this.$axios.post(
      `${this.apiUrl}Addresses/SG/Search?track=true&useFranchizeZipAssignments=true`,
      address
    ).then(function(response) {
      return response.data[0];
    })
    .catch(function(error) {
      return {error: error, response: error.response.data };
    });
  }

  async getUser(id) {
    return await this.$axios.get(
      this.apiUrl + "Users/User/" + id
    ).then(function(response) {
      return response.data[0];
    })
    .catch(function(error) {
      return {error: error, response: error.response.data };
    });
  }

  /**
   * get user by unique id
   * @param {*} id 
   */
  async getUsersByUniqueId(id) {
    return await this.$axios.get(
      this.apiUrl + "Users/UniqueUserId/" + id
    ).then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      return {error: error, response: error.response.data };
    });
  }

  /**
   * Create new user account
   * @param {*} user 
   * @returns 
   */
  async createUser(user) {
    return await this.$axios.post(
      this.apiUrl + "Users/User",
      user
    ).then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      return {error: error, response: error.response.data };
    });
  }

  /**
   * update user account
   * @param {*} user 
   * @returns 
   */
   async updateUser(id, user) {
    return await this.$axios.put(
      this.apiUrl + "Users/User/" + id,
      user
    ).then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      return {error: error, response: error.response.data };
    });
  }
  
   async updatePatchUser(id, operations) {
    return await this.$axios.patch(
      this.apiUrl + "Users/User/" + id,
      operations
    ).then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      return {error: error, response: error.response.data };
    });
  }

  async migratePortalCustomer(id, request) {
    return await this.$axios.post(
      this.apiUrl + "Users/User/" + id + "/MigratePortalCustomer",
      request
    ).then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      return { error: error, response: error.response?.data };
    });
  }


  /**
   * Create residenceId
   * @param {*} user 
   * @returns 
   */
   async createResidenceId(id, sqldbid) {
    return await this.$axios.get(
      this.apiUrl + "Customers/Customer/" + id + "/Company/" + sqldbid + "/ResidenceId/Generate"
    ).then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      return {error: error, response: error.response.data };
    });
  }

  /**
   * update user account
   * @param {*} user 
   * @returns 
   */
   async updateAzureUser(id, userObject) {
    return await this.$axios.patch(
      this.apiUrl + "Users/SpringGreenB2C/User/" + id,
      userObject
    ).then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      return {error: error, response: error.response.data };
    });
  }
}
